/**
 * Get a list column definition
 */
export const gridListColumnSelector = state => state.listViewColumn;